
if (window.innerWidth <= 768) {
    // Code for mobile devices (screen width less than or equal to 768px)
} else {
// Select the element you want to animate
const elementToAnimate = document.querySelector('.wine-img img');
const elementToAnimate2 = document.querySelector('.btn2');
const elementToAnimate3 = document.querySelector('.wine-name');

gsap.set(elementToAnimate2, { y:-100 });
gsap.set(elementToAnimate3, { y:-100 });

// Define the animations for section 1 and section 2
const animation1 = gsap.to(elementToAnimate2, {
    y: 0,
    opacity: 1,
    duration: 1,
    paused: true,
  });

  const animation2 = gsap.to(elementToAnimate3, {
    y: 0,
    opacity: 1,
    duration: 1,
    paused: true,
  });

  const animation2b = gsap.to(elementToAnimate, {
    opacity: 0,
    duration: 1,
    paused: true,
  });

  const animation3 = gsap.to(elementToAnimate3, {
    opacity: 0,
    PointerEvents: "none",
  });
  const animation5 = gsap.to(elementToAnimate2, {
    opacity: 0,
    PointerEvents: "none",
  })


  // Define ScrollTrigger for section 1
  ScrollTrigger.create({
    trigger: '.content-load2', // Trigger element
    start: 'top-=300px top+=200', // Start 200 pixels before the section fully enters the viewport
    end: 'top+=200px center', // End when the section fully leaves the viewport
    animation: animation1,
    scrub: true, // Enable scrubbing
  });
  ScrollTrigger.create({
    trigger: '.content-load2', // Trigger element
    start: 'top-=300px top+=200', // Start 200 pixels before the section fully enters the viewport
    end: 'top+=200px center', // End when the section fully leaves the viewport
    animation: animation2,
    scrub: true, // Enable scrubbing
  });
  ScrollTrigger.create({
    trigger: '.content-load2', // Trigger element
    start: 'top-=300px top+=200', // Same window as the title fade-in, so the bottle fades out as the title fades in
    end: 'top+=200px center',
    animation: animation2b,
    scrub: true, // Enable scrubbing
  });
  ScrollTrigger.create({
    trigger: '.content-load2', // Trigger element
    start: 'bottom-=600px center', // Start 200 pixels before the section fully enters the viewport
    end: 'bottom-=400px center', // End when the section fully leaves the viewport
    animation: animation3,
    scrub: true, // Enable scrubbing
  });
  ScrollTrigger.create({
    trigger: '.content-load2', // Trigger element
    start: 'bottom-=600px center', // Start 200 pixels before the section fully enters the viewport
    end: 'bottom-=400px center', // End when the section fully leaves the viewport
    animation: animation5,
    scrub: true, // Enable scrubbing
  });



$('.wine-name').on('mouseenter', function(){
 gsap.to(this, {
     scale: .9,
     duration: .1,
     y: -20,
     ease: "power2.out",
 })
})

$('.wine-name').on('mouseleave', function(){
    gsap.to(this, {
        scale: .8,
        duration: .1,
        y: 0,
        ease: "power2.out",
    })
   })

}
